import React, { PureComponent } from 'react';
import { Button } from 'antd';
import { language } from '../../../language';
import { SelectCustomUrl } from '../select-custom-url';

export class CustomUrlSelector extends PureComponent<
    {
        value: any;
        modalConfig: Record<string, any>;
        onChange: (value: any) => void;
    },
    { visibleModal: boolean }
> {
    state = {
        visibleModal: false,
    };

    showModal = () => {
        this.setState({ visibleModal: true });
    };
    hideModal = () => {
        this.setState({ visibleModal: false });
    };
    onChange = (value) => {
        const { onChange } = this.props;
        this.hideModal();
        onChange(value);
    };

    render() {
        const {
            value: { linkParams },
            modalConfig,
        } = this.props;

        const { visibleModal } = this.state;
        const hasTarget = linkParams;
        const selectProps = {
            value: linkParams,
            onChange: this.onChange,
        };
        return (
            <span className="link-name">
                {hasTarget ? (
                    <a href={linkParams} target="_blank">
                        链接
                    </a>
                ) : (
                    '未选择'
                )}
                <Button type={'link'} onClick={this.showModal} className="link-type-edit">
                    {hasTarget
                        ? language.getText('components.Tools.modify')
                        : language.getText('components.Tools.select')}
                </Button>
                <SelectCustomUrl
                    modalConfig={modalConfig}
                    showModal={visibleModal}
                    onCancel={this.hideModal}
                    {...selectProps}
                />
            </span>
        );
    }
}
